import { PF } from '@app/pages/Warehouses/Inventory/data';
import {
  useInventory,
  useInventoryEffects,
} from '@app/pages/Warehouses/Inventory/hooks';
import { InventoryTable } from '@app/pages/Warehouses/Inventory/ui';

import '@pages/Warehouses/Inventory/styles/Inventory.scss';

export const Inventory = () => {
  const {
    columns,
    tableData,
    total,
    filters,
    range,
    isPageLoading,
    handlePaginationChange,
    searchInventoriesHandler,
  } = useInventory();

  useInventoryEffects({ searchInventoriesHandler });

  return (
    <div className={`${PF}_container`}>
      <div className={`${PF}_table-section`}>
        <InventoryTable
          columns={columns}
          data={tableData}
          filters={filters}
          total={total}
          range={range}
          handlePaginationChange={handlePaginationChange}
          isPageLoading={isPageLoading}
        />
      </div>
    </div>
  );
};
